import React, { useState, useContext } from 'react';
import { MessageType, Message } from '@wearejh/m2-pwa-engine/lib/types';

import { BranchFinder } from 'src/components/GoogleMaps/GoogleMapsTypes';
import { useGoogleMapsApi } from 'src/components/GoogleMaps/GoogleMapsApiProvider';
import { BranchLocationQueryContext } from 'src/components/StoreLocator/BranchLocationQuery';
import { LocationLookup } from 'src/components/LocationLookup/LocationLookup';
import { BranchList } from 'src/components/GoogleMaps/BranchList';
import { BranchCard } from 'src/components/GoogleMaps/BranchCard';
import { getCurrentLocation } from 'src/util/getCurrentLocation';

import { SpaceAbove } from '../Helpers/Block';
import { Messages } from '../Messages/Messages';

function BranchFinder({ visibleBranches, visibleCount, onChange }: BranchFinder) {
    const { getAddressCoordinates, sortByDistance } = useGoogleMapsApi();
    const { branches } = useContext(BranchLocationQueryContext);
    const [query, setQuery] = useState('');
    const [messages, setMessages] = useState<Message[]>([]);
    const [status, setStatus] = useState('idle');

    // Triggers when a new search string has been searched for
    function handleSearchChange(newQuery) {
        setStatus('pending');
        setMessages([]);

        getAddressCoordinates(newQuery).then(
            (result) => {
                const { lat, lng } = result;
                const sortedBranches = sortByDistance(lat, lng, branches).slice(0, visibleCount);

                onChange(sortedBranches);
                setQuery(newQuery);
                setStatus('success');
            },
            (error) => {
                setMessages([{ text: error, type: MessageType.Error }]);
                setStatus('idle');
            },
        );
    }

    // Triggers when the user is getting their current location
    function handleGeoLocationChange() {
        setStatus('pending');
        setMessages([]);

        getCurrentLocation().then(
            (result) => {
                const { lat, lng } = result;
                const sortedBranches = sortByDistance(lat, lng, branches).slice(0, visibleCount);

                onChange(sortedBranches);
                setQuery('');
                setStatus('success');
            },
            (error) => {
                setMessages([{ text: error, type: MessageType.Error }]);
                setStatus('idle');
            },
        );
    }

    return (
        <div>
            <LocationLookup
                pending={status === 'pending'}
                submitAddress={handleSearchChange}
                submitGeo={handleGeoLocationChange}
            />

            <SpaceAbove>
                {messages.length > 0 && <Messages messages={messages} />}

                {status === 'success' && visibleBranches && visibleBranches.length > 0 && (
                    <BranchList query={query} branches={visibleBranches}>
                        {({ branch }) => <BranchCard branch={branch} />}
                    </BranchList>
                )}
            </SpaceAbove>
        </div>
    );
}

export { BranchFinder };
